<template>
    <div class="whychoice">
        <AdenTitle class="mb-[42px]" :titles="['7大特色餐厅，800多道东西方美食免费享用']"></AdenTitle>
        <div class="banner"></div>
    </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";
import AdenTitle from "@/views/topic/202208/aden/components/aden-title.vue";


export default defineComponent({
    name: "DeliciousFood",
    components: {
        AdenTitle
    },
    props: {
        titles: []
    },
    data() {
        return {

        }
    }
})
</script>

<style lang="scss" scoped>
.whychoice {
  padding-top: 50px;
}
.banner {
  height: 867px;
  background: url(~views/topic/202208/aden/imgs/food.png) no-repeat center;
  background-size: auto 867px;
}
</style>
